module.exports = __webpack_public_path__ + "static/media/beach_resort.bcb9b50c.png";